import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PriceComponentDef } from '@df/ui/price/price.component.def';

/**
 * Price presentation component.
 *
 * @example
 * ```html
 * <price [value]="some.price" [precision]="2"></price>
 * ```
 */
@Component({
    selector: 'price',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [
        `
            :host {
                white-space: nowrap;
            }
        `
    ],
    standalone: true,
    template: '{{getText()}}' // if you need html version please use local component instead (this is better performing)
})
export class PriceComponent extends PriceComponentDef {}
